/**
 * Constants and utility functions for RequestDetailPage
 */

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const SHIPPING_METHODS = [
  'Standard Delivery', 'Express Delivery', 'Overnight Delivery', 'Same Day Delivery',
  'Click & Collect', 'Freight / Pallet', 'Air Freight', 'Sea Freight',
  'Courier (DHL)', 'Courier (FedEx)', 'Courier (UPS)', 'Royal Mail / Post', 'Digital Delivery'
];

export const INCOTERMS_LIST = ['EXW', 'FCA', 'CPT', 'CIP', 'DAP', 'DDP', 'FAS', 'FOB', 'CFR', 'CIF'];

export const STATUS_STYLES = {
  DRAFT: 'text-gray-600 bg-gray-100',
  UNAPPROVED: 'text-blue-700 bg-blue-100',
  PENDING: 'text-amber-700 bg-amber-100',
  ORDER: 'text-cyan-700 bg-cyan-100',
  RFQ: 'text-red-700 bg-red-100',
  DORMANT: 'text-emerald-700 bg-emerald-100',
  TEMPLATE: 'text-gray-500 bg-gray-200',
  APPROVED: 'text-green-700 bg-green-100',
  REJECTED: 'text-red-700 bg-red-100',
  CANCELLED: 'text-gray-700 bg-gray-200',
};

export const EDITABLE_STATUSES = new Set(['DRAFT', 'UNAPPROVED', 'DORMANT']);

/**
 * Format date for display
 */
export const formatDate = (d, timezone) => {
  if (!d) return '';
  try {
    const opts = { day: '2-digit', month: 'short', year: 'numeric' };
    if (timezone) opts.timeZone = timezone;
    return new Date(d).toLocaleDateString('en-GB', opts);
  } catch {
    return d;
  }
};

/**
 * Format timestamp for display
 */
export const formatTimestamp = (d, timezone) => {
  if (!d) return '';
  try {
    const opts = {
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
    };
    if (timezone) opts.timeZone = timezone;
    return new Date(d).toLocaleString('en-GB', opts);
  } catch {
    return d;
  }
};

/**
 * Create a blank line item
 */
export const createBlankLineItem = (num) => ({
  id: `temp-${Date.now()}`,
  item_num: num,
  item_code: '', item_description: '', quantity: 1, unit: 'EACH',
  unit_price: 0, pack_size: 1, discount: 0, net_price: 0,
  supplier_code: '', supplier_name: '',
  account_code_4: '', account_code_5: '', account_code_6: '',
  account_code_4_pct: 100, account_code_5_pct: 0, account_code_6_pct: 0,
  category_code: '', delivery_point_code: '', document_type_code: '',
  item_due_date: new Date().toISOString().split('T')[0],
  contract_number: '', co2e: 0, notes: '', punchout_source: '', punchout_item_url: ''
});
